export enum EParticipant {
  FROM = 1,
  TO = 2,
}
